import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  useBackgroundDispatch,
} from 'src/hooks'
import { useIsUserOrglessRCNOwner } from 'src/hooks/useOrglessUserStatus'
import { Rdrct } from 'src/navigation/Lnk'
import { cardsPhysicalCardsUrl } from 'src/navigation/urls'
import { createSetIsSetupOrganizationPopupOpen } from 'src/redux/actions/app.actions'
import { selectIsConfirmOrgModalAccountAccountsDismissed } from 'src/redux/selectors/auth.selectors'

const AccountsAccounts: React.FC = () => {
  const isUserOrglessRCNOwner = useIsUserOrglessRCNOwner()
  const isConfirmOrgModalAccountAccountsDismissed = useSelector(
    selectIsConfirmOrgModalAccountAccountsDismissed,
  )
  const dispatch = useBackgroundDispatch()

  useEffect(() => {
    if (!!isUserOrglessRCNOwner && !isConfirmOrgModalAccountAccountsDismissed) {
      dispatch(createSetIsSetupOrganizationPopupOpen(true))
    }
  }, [isUserOrglessRCNOwner])

  return (
    <Rdrct to={cardsPhysicalCardsUrl()} />
  )
}

export default AccountsAccounts
